<div role="main">
    
    <app-header></app-header>
    <div>
        <div class="col-md-6 offset-md-1 d-flex align-items-center">
            <span class="text-white-ref ref">Reference ID</span>
            <span class="ref-id-no ms-2">{{ service.referenceFileDetails.referenceId }}</span>
        </div>

        <form (ngSubmit)="onSubmit()" class="referenceheader">
            <div class="row link-container">
                <div class="col-md-auto offset-md-1 mt-3">
                    @if (service.hasVisited('reference')) {
                      <a class="btn btn-info custom-button" (click)="service.navigateTo('reference')">Contact Information</a>
                    }
                </div>
                <div class="col-md-auto mt-3">
                    @if (service.hasVisited('file-upload')) {
                      <a class="btn btn-info custom-button" (click)="service.navigateTo('file-upload')">File Upload</a>
                    }
                </div>
                <div class="col-md-auto mt-3">
                    <a class="btn btn-info-current custom-button">Review & Submit Files</a>
                </div>
            </div>

            <div class="row" style="margin-top: 20px;">
                <div class="col-md-6 offset-md-1 mt-3">
                    <div class="d-flex justify-content-end mb-1">
                        <span class="text-white-sub">File Count: {{ files.length }}</span>
                    </div>
                    <div class="table-div">
                    <div class="overflow-auto">
                        <table class="table text-white review-files-table">
                            <thead>
                                <tr>
                                    <th class="col-md-4" scope="col"><span style="padding-left: 25px;">Action</span>
                                    </th>
                                    <th class="col-md-4" scope="col">File Name</th>
                                    <th class="col-md-4" scope="col">File Size</th>
                                </tr>
                            </thead>
                            <tbody>
                                @for (item of files; track item; let i = $index) {
                                  <tr>
                                    <td class="col-md-4">
                                        <button type="button" class="btn-enter" id="removeFileButton" [disabled]="fileSubmitted && item.isVisible != (item.attachmentKey + '_99')"
                                            (click)="removeFile(i)">Remove File</button>
                                    </td>
                                    <td class="col-md-4 text-white-sub">{{item.fileName}}</td>
                                    <td class="col-md-4 text-white-sub" style="text-align: left;">{{item.fileSize |
                                        fileSize}}
                                    </td>
                                  </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                    <table class="table text-white review-files-footer-table" style="margin-bottom: 0px;">
                        <tbody>
                            <tr>
                                <td class="col-md-4">
                                    <button type="button" class="btn-enter" id="addNewFileButton"
                                        (click)="addNewFile()">Add
                                        Additional Files</button>
                                </td>
                                <td class="col-md-3"><span class="pull-left">Total</span></td>
                                <td class="col-md-3"><span class="pull-left">{{totalFilesSize | fileSize}}</span></td>
                                <td class="col-md-2"></td>
                            </tr>
                        </tbody>
                    </table>
                    </div>
                </div>

                <div class="col-md-5 mt-3">
                    <span class="text-white">Upload Review:</span>
                    <div>
                        <span class="text-white-sub">❑ Confirm all requested files have been uploaded with individual
                            file
                            names.</span>
                    </div>
                    <div>
                        <span class="text-white-sub">❑ To Add Files not previously uploaded, select Add Additional
                            Files.</span>
                    </div>
                    <div>
                        <span class="text-white-sub">❑ To Remove individual files, select Remove File.</span>
                    </div>
                    <br/>
                    <span class="text-white">Submit Files:</span>
                    <div>
                        <span class="text-white-sub">❑ Once you have verified the number of files, click the Submit Files button to complete the submission. 
                            Please note, you cannot navigate back once files are submitted.
                        </span>
                    </div>
                    <div>
                        <span class="text-white-sub">❑ Once files have successfully uploaded, you will receive a Confirmation email. If a problem occurs during file transfer,
                            you will be notified and may be asked to re-submit any files that failed to upload.
                        </span>
                    </div>
                </div>
            </div>



            <div class="col-md-6 offset-md-1" style="margin-top: 25px;">
                <div class="button-group">
                    <button type="button" class="btn-clear" id="backButton" (click)="back()">Back</button>
                    <button type="submit" class="btn-enter" id="submitButton" [disabled]="isDisabled">Submit Files</button>
                    @if (showFileUploadError) {
                      <div class="error-container"><span class="text-danger">Try again or remove the invalid file and click Submit Files to complete the process.</span></div>
                    }
                </div>
            </div>
        </form>
        @if (openUploadModal) {
          <app-file-status [files]="files" [uploadedFiles]="uploadedFiles" (uploadCompleted)="handleUploadCompleted($event)" (uploadClosed)="closeUploadPopup()"> </app-file-status>
        }

        <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="large" color="#fff" type="ball-scale-multiple"
            [fullScreen]="true">
            <p style="color: white">Please do not Cancel or Refresh page</p>
        </ngx-spinner>

        <!-- Footer -->
        <app-footer></app-footer>
    </div>
</div>
